import { motion } from "motion/react";

import type { JSX } from "react";

export function AnimatedItem({
    delay,
    children,
    style,
    className,
}: {
    delay?: number;
    children?: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
}): JSX.Element {
    return (
        <motion.div
            initial={{ opacity: 0, y: 40 }}
            variants={{
                active: {
                    opacity: 1,
                    y: 0,
                    transition: { delay, type: "spring", duration: 0.8 },
                },
                inactive: {
                    opacity: 0,
                    y: 40,
                    transition: { delay, type: "spring", duration: 0.8 },
                },
            }}
            style={style}
            className={className}
        >
            {children}
        </motion.div>
    );
}
